import * as images from './images';

export function getCardImage(fileName: string): string {
  if (fileName in images) return images[fileName as keyof typeof images];
  if (`_${fileName}` in images) return images[`_${fileName}` as keyof typeof images];
  throw new Error(`Card image not found: ${fileName}`);
}
